import { DomainV2 } from 'troppus-common/domain';

import { importTableDefinitionColumnTypeLabel } from '../importTableDefinitionColumnTypeLabel';

import type { FormValues } from './types';

import ImportTableDefinition = DomainV2.Import.ImportTableDefinition;

export const DEFAULT_CUSTOMER_IDENTIFIER_TYPE = 'default' as const;

export const DEFAULT_VALUES: FormValues = {
  sourceSystemId: '',
  displayName: '',
  description: '',
  loadMode: 'Replace',
  columns: [],
  contractUkColumns: [],
  customerUkEnabled: false,
  customerUkColumns: [],
};

export const typeOptions = (
  ['string', 'number', 'date', 'boolean'] as const satisfies readonly ImportTableDefinition.SchemaJson.Column['type'][]
).map((value) => ({ value, label: importTableDefinitionColumnTypeLabel(value) }));

export const loadModeOptions = [{ value: 'Replace' as const, label: '洗い替え' }];
